import { z } from 'zod';

const inputEntrySchema = z.object({
  kind: z.literal("input"),
  value: z.string()
});

export { inputEntrySchema };
//# sourceMappingURL=InputEntry.js.map
